import { render, staticRenderFns } from "./print-previous-replies.vue?vue&type=template&id=22114466&"
import script from "./print-previous-replies.vue?vue&type=script&lang=js&"
export * from "./print-previous-replies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports